<template>
  <QLayout view="lHh lpr lFf">
    <MenuDrawer />
    <QPageContainer>
      <QPage class="column">
        <HeaderWidget class="full-width" />
        <router-view />
      </QPage>
    </QPageContainer>
    <QFooter>
      <InLifeFooterWidget />
    </QFooter>
  </QLayout>
</template>

<script>
import { QLayout, QPageContainer, QPage, QFooter } from 'quasar';

export default {
  name: 'MainLayout',
  components: {
    QLayout,
    QPageContainer,
    QPage,
    QFooter,
    MenuDrawer: () => import('../../../widgets/menu-drawer'),
    HeaderWidget: () => import('../../../widgets/header'),
    InLifeFooterWidget: () => import('../../../widgets/in-life-footer')
  }
};
</script>
